module.exports = __webpack_public_path__ + "img/pointer.1ae769b5.png";